import React, { Component } from 'react';
import cross from '../../assets/images/close_popup.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/advertisement/AdvertisementData.css';
import 'react-calendar/dist/Calendar.css';
import Loader from 'react-loader';
class PreviewModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageLink: '',
            loaderTime: true,
            advertisementData: this.props.advertisementData,
            previewIndex: this.props.previewIndex,
        }
    }
    componentDidMount() {
        console.log(this.state.advertisementData[this.state.previewIndex])
        this.setState({ loaderTime: this.props.advertisementData[this.props.previewIndex] !== undefined ? false : true })
    }
    componentWillReceiveProps(nextProps) {
        this.setState({ loaderTime: this.props.advertisementData[this.props.previewIndex] !== undefined ? false : true })
        this.setState({ imageLink: this.state.advertisementData[this.state.previewIndex] });
        console.log('componentWillReceiveProps', nextProps);
        this.setState(nextProps);
    }
    render() {
        return (
            <div class="advertisementModalOuter" >
                <div class="advertisementModalInner" style={{ paddingBottom: '0px', width: "80%", height: "385px" }}>
                    <Loader
                        loaded={!this.state.loaderTime}
                        lines={10}
                        length={10}
                        width={10}
                        radius={10}
                        corners={1}
                        rotate={0}
                        direction={1}
                        color="#000"
                        speed={1}
                        trail={60}
                        shadow={false}
                        hwaccel={false}
                        className='spinner'
                        zIndex={2e9}
                        top="50%"
                        left="50%"
                        scale={1.0}
                        loadedClassName="loadedContent"
                    />
                    <div className='advertisementcross' style={{ top: "65px", right: "-98%" }}>
                        <img src={cross} width="21" height="21" onClick={this.props.onClick} class="d-inline-block align-top" alt="" loading="lazy" />
                    </div>
                    <div style={{ marginTop: '7.8%' }}>
                        <img alt="Mobile Image"
                            src={this.state.imageLink}
                            width='1062' height='390'
                        />
                    </div>
                </div>
            </div>
        );
    }
}
export default PreviewModal;